import Cookies from 'universal-cookie';

// Read and write the "My Bookings" history (shape: { submitted: [...] }).
//
// This used to live in a cookie, but the booking app is embedded in the main site as a
// cross-site iframe. Browsers block third-party cookies inside that iframe, so bookings
// never showed up in My Bookings. localStorage works inside the iframe and also survives
// closing the browser.

const STORAGE_KEY = 'formSubmitted';
const cookies = new Cookies();

// Returns the stored booking history, or undefined when nothing is stored.
export const getBookingHistory = () => {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
  } catch (error) {
    // localStorage may be blocked by the browser (e.g. an iframe in incognito) or hold corrupted data.
    console.error('Failed to read booking history from localStorage', error);
  }

  // Fallback: older versions stored history in a cookie, so standalone users keep their past bookings.
  return cookies.get(STORAGE_KEY);
};

// Saves the booking history. Failures are only logged, never thrown, so the booking flow is not interrupted.
export const saveBookingHistory = (history) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(history));
  } catch (error) {
    console.error('Failed to save booking history to localStorage', error);
  }
};
